var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3H16.6665V1C16.6665 0.4475 16.219 0 15.6665 0H8.3335C7.781 0 7.3335 0.4475 7.3335 1V3H0V4H3.1855C3.1855 4.0335 3.1815 4.0655 3.185 4.0995L4.986 22.109C5.0935 23.1825 5.9965 24 7.0755 24H16.9245C18.0035 24 18.9065 23.1825 19.014 22.109L20.815 4.0995C20.8185 4.0655 20.8145 4.0335 20.8145 4H24V3ZM8.3335 1H15.667V3H8.3335V1ZM18.019 22.0095C17.9625 22.574 17.492 23 16.9245 23H7.0755C6.508 23 6.0375 22.574 5.981 22.0095L4.18 4H19.8205L18.019 22.0095Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6H11.5V21H12.5V6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0009 5.96579L15.0012 20.9662L15.999 21.0327L16.9987 6.03229L16.0009 5.96579Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9989 5.96714L7.0011 6.03364L8.00083 21.0341L8.99863 20.9676L7.9989 5.96714Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.bf1b3128e0f0d728aeff097764fbe579.svg";
export { ForwardRef as ReactComponent };